import { useState, useEffect } from 'react';

import { mockMapConfig } from 'data/mapConfig';
import { IS_DEBUG } from 'constants.js';

import { useStaleData } from '@timmons-group/shared-react-components/hooks';
import axiosRetry from 'axios-retry';
import axios from 'axios';

// TODO: Switch to the SRC version of this hook once backend/database is updated to no longer need "pam" in the URL
export const useLayout = (type, key) => {
  const url = `/api/pam/Layout/GetLayout?objectType=${type}&layoutKey=${key}`;

  const [data, isLoading ] = useStaleData(url, {});
  return [data, isLoading];
}

/**
 * Hook to fudge the WMS DescribeLayer response with the mapConfig instead...for now
 * @returns array of useState properties layers and loading state
 */
export const useReferenceLayers = () => {
  const url = `/api/map/config/getForMap/new_planning_area`;

  // If debug mode is enabled, we will use the fake data
  const defaultValue = IS_DEBUG ? mockMapConfig : [];
  const [data, isLoading ] = useStaleData(url, defaultValue, false);
  const [refLayers, setRefLayers] = useState([]);
  const [refLoading, setRefLoading] = useState(true);
  const lyrGrpKey = 'grp_new_planning_area_reference';

  // Monitor the loading state of the data and update this hook's state
  // This prevents the component using this hook from having to handle the parsing itself
  // We do not need to clean up the useEffect as the stateData hook does it for us
  useEffect(() => {
    if (!isLoading) {
      const group = data?.layerGroups.find(grp => grp.key === lyrGrpKey) || null;
      if (group) {
        const opts = group.layers.map((lName, i) =>{
          const layer = data.layers.find(l => l.key === lName) || { name: 'Not Found', key: i };
          return {
            name: layer.name || 'Not Found',
            id: layer.key || i
          }
        });
        setRefLayers(opts);
      }

      setRefLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);
  return [refLayers, refLoading];
}

/**
 * Hook to use axios-retry to retry a request if it fails with a 504 error
 * This happens when the database is not available
 **/
axiosRetry(axios, {
  retries: 3, // number of retries
  retryDelay: (retryCount) => {
    console.log(`LOCA retry attempt: ${retryCount}`);
    return retryCount * 2000; // time interval between retries
  },
  retryCondition: (error) => {
    // if retry condition is not specified, by default idempotent requests are retried
    return error.response.status === 504;
  },
});